// One React build serves two sites: nellab.org (the main site) and
// app.nellab.org (the YNO app landing page). The hostname decides which one
// renders, so each Firebase Hosting site can deploy the same build.

// app.nellab.org, plus the default Firebase URLs of its hosting site so the
// page can be checked before the custom domain is connected.
const APP_HOSTS = /^(app\.|yno-nellab-app\.)/;

export function isAppSite() {
  const { hostname, search } = window.location;
  // ?site=app previews the landing page from localhost or any other host
  return APP_HOSTS.test(hostname) || new URLSearchParams(search).get("site") === "app";
}
